import getConfig from 'libs/get.config';
import { isSMBPortal } from 'utils/applicationHelper';

export const getServerEndpoint = (): string => {
  return isSMBPortal()
    ? getConfig({ configName: 'api.SMB_SERVER_ENDPOINT', isRequired: true })
    : getConfig({ configName: 'api.RESI_SERVER_ENDPOINT', isRequired: true });
};
export const getSecurityChecksEndpoint = (): string =>
  getConfig({ configName: 'api.SECURITY_CHECKS_ENDPOINT', isRequired: true });
export const getRefreshTokenEndpoint = (): string =>
  getConfig({ configName: 'api.REFRESH_TOKEN_ENDPOINT', defaultValue: '/refresh-token' });
